import { useContext, useState } from "react";
import Drawer from "@material-ui/core/Drawer";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// assets
import CheckOff from "bodycodi/cmap/app/img/checkbox-round-off.svg";
import CheckOn from "bodycodi/cmap/app/img/checkbox-round-on.svg";

// utils
import { api } from "bodycodi/cmap/app/js/api";

const AgreePopup = ({ seqNewSettlementPayroll, lastRequestDt, closeAfterAction }: any) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [agree, setAgree] = useState(false);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "SALARY_AGREE_POP",
      open: { salaryAgreePop: false },
    });
    setAgree(false);
  };

  const agreeRequest = async () => {
    try {
      await api
        .patch("/payroll/settlement/payrolls/confirm", {
          seqNewSettlementPayroll,
          lastRequestDt,
        })
        .then(({ data }) => {
          handleClose();
          closeAfterAction();
        });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.salaryAgreePop}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <div className="picker-body salary-agree-pop">
        <header>급여 내역 동의</header>
        <span className="reminder">{`급여내역을 모두 확인했나요? 급여 내용을 동의하면, \n확인한 급여내역으로 지급이 진행됩니다.`}</span>
        <div className="detail" onClick={() => setAgree(!agree)}>
          <img src={agree ? CheckOn : CheckOff} />
          <span>
            본인은 근로계약 형태에 따라 맡은 업무를 수행하였고 급여내역서에 포함된 업무 내역이
            사실과 다름 없음을 확인했으며, 급여· 수당 내역에 동의합니다.
          </span>
        </div>
        <button disabled={!agree} onClick={agreeRequest}>
          급여 · 수당 내역에 동의합니다.
        </button>
      </div>
    </Drawer>
  );
};

export default AgreePopup;
